'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.oem_user_create', {
    url: '/user_create',
    template: '<oem-user-create></oem-user-create>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/oem_user/create/oem_user_create.routes.js